<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Subscription Report Details</b-navbar-brand>

          <b-navbar-nav class="ml-auto"> </b-navbar-nav>
        </b-navbar>

        <b-card>
          <md-layout md-gutter class="align-items-center">
            <md-layout :md-flex="dateRange.startDate ? '30' : '15'">
              <date-range-picker
                :opens="openRight"
                :always-show-calendars="showCal"
                v-model="dateRange"
                :startDate="startDate"
                :endDate="endDate"
                :locale-data="locale"
              >
              </date-range-picker>
            </md-layout>
            <!-- <md-layout md-flex="15">
              <date-picker
                :format="selectDateFormat"
                lang="en"
                name="shippingBillNo"
                id="shippingBillNo"
                v-model="DateFilter"
                :minute-step="1"
              ></date-picker>
            </md-layout> -->

            <md-layout md-gutter>
              <b-button
                size="sm"
                class="ml-auto"
                @click="filterSearch"
                variant="outline-primary"
                >Search</b-button
              >

              <b-button size="sm" class="ml-3" @click="clearFilter" variant="outline-info"
                >clear</b-button
              >
              <!-- <b-button
                size="sm"
                class="ml-3"
                @click="getReportsAss('MainAssignment_SCREEN')"
                variant="outline-info"
                >Export as Excel</b-button
              > -->
              <b-button
                :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                class="ml-3"
                @click="getReportsAss('MainAssignment_SCREEN', 'Export as Excel')"
                size="sm"
                variant="outline-info"
                >{{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export as Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>

              <b-button
                :disabled="ExcelBtnName1 != 'Webhook Excel' ? true : false"
                class="ml-3"
                @click="getWebhookReport('All_Webhook_List', 'Webhook Excel')"
                size="sm"
                variant="outline-info"
                >{{ ExcelBtnName1 }}
                <b-spinner
                  v-if="ExcelBtnName1 != 'Webhook Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
              <!-- <b-button
                size="sm"
                class="ml-3"
                @click="getReportsAss('MainAssignment_All_Summary_SCREEN')"
                variant="outline-info"
                >Export as All Summary Excel</b-button
              > -->
              <b-button
                :disabled="
                  AllSummaryExcelBtnName != 'Export as All Summary Excel' ? true : false
                "
                class="ml-3"
                @click="
                  getReportsAss(
                    'MainAssignment_All_Summary_SCREEN',
                    'Export as All Summary Excel'
                  )
                "
                size="sm"
                variant="outline-info"
                >{{ AllSummaryExcelBtnName }}
                <b-spinner
                  v-if="AllSummaryExcelBtnName != 'Export as All Summary Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
            </md-layout>
          </md-layout>
        </b-card>

        <div class="box">
          <div>
            <b-pagination
              class="mt-3"
              limit="10"
              style="margin: 0px"
              align="right"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              @change="onPageChange($event)"
            ></b-pagination>
          </div>
          <h5 class="text-muted pull-right mt-2 ml-3">
            <small v-if="isLoading == false">{{ totalRows }} Entries</small>
          </h5>
          <div class="table-responsive tableMain gutr">
            <b-table
              show-empty
              stacked="md"
              :items="subs_details"
              :fields="fields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <template slot="sr_no" slot-scope="row0">
                <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              </template>
              <template slot="tot_attempt_subscription" slot-scope="row1">
                <b>{{ row1.item.total_attempt }}</b>
              </template>
              <template slot="tot_success_subs" slot-scope="row2">
                {{ row2.item.total_success }}
              </template>

              <template slot="tot_failed_subs" slot-scope="row3">
                <div v-if="row3.item.total_failed">
                  <h6>
                    <b-badge variant="light">{{ row3.item.total_failed }} </b-badge>
                  </h6>
                </div>
              </template>
              <template slot="subs_create_date" slot-scope="row4">
                <div v-if="row4.item.subs_date">
                  <h6>
                    <b-badge variant="light">{{ row4.item.subs_date }} </b-badge>
                  </h6>
                </div>
              </template>
            </b-table>
          </div>
        </div>

        <div>
          <h5>
            <b-pagination
              limit="10"
              align="center"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              @change="onPageChange($event)"
            ></b-pagination>
          </h5>
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  lastVisitPage,
} from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import DocForm from "./docLibrary.vue";
import OceanInsightsSubscriptionService from "../../services/OceanInsightsSubscriptionService.js";

export default {
  beforeMount() {
    this.getCurrentLastDate();
    lastVisitPage(this.$router.history.current.fullPath);
    this.$store.dispatch("setCurrentRoute", "/mainReport");
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != "" &&
      this.$sessionsStorage.get("departmentName") != undefined &&
      this.$sessionsStorage.get("departmentName") != "" &&
      this.$sessionsStorage.get("designation") != undefined &&
      this.$sessionsStorage.get("designation") != ""
    ) {
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewSubscription("0", "1", "1");
      }
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      ExcelBtnName: "Export as Excel",
      ExcelBtnName1: "Webhook Excel",
      AllSummaryExcelBtnName: "Export as All Summary Excel",
      selectDateFormat,
      subs_details: [],
      docURL: URL_BASE_DOC,
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      eventId: "",
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openRight: "right",
      showCal: false,
      showDash: false,

      // date: ['2018-06-01'],
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      totalRows: 1000000000000000,
      currentPage: 1,
      perPage: 50,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {
          key: "sr_no",
          mainkey: "sr_no",
          label: "SN",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "tot_attempt_subscription",
          mainkey: "tot_attempt_subscription",
          label: "Total Attempt Subscription",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "tot_success_subs",
          mainkey: "tot_success_subs",
          label: "Total Success Subscription",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "tot_failed_subs",
          mainkey: "tot_failed_subs",
          label: "Total Failed Subscription",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "subs_create_date",
          mainkey: "subs_create_date",
          label: "Subscription Date",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
      ],

      mailallModuleId: "",
      mailExecSeries: "",
      incompleteJobBill: "",
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      DateFilter: "",
      assignmentNo: "assignmentNo",
      selectedAllModuleId: "",
      reload: true,
      webhookList: [],
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
    DocForm,
  },

  computed: {},
  watch: {},
  methods: {
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      // alert(firstDay);
      // alert(lastDay);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      //  alert(firstDay);
      // alert(lastDay);

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      // alert(today);
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };

      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    validateBilling(id, jobType) {
      this.selectedAllModuleId = id;
      this.isLoading = true;

      let payload = {
        allModuleId: id,
        job: jobType,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/validateCloseBilling.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.incompleteJobBill.length > 0) {
              this.incompleteJobBill = data.incompleteJobBill.toString();
            }
            this.$refs["modal-close-conf"].show();
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },

    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    getWebhookReport(id, Excell_type) {
      this.webhookList = [];
      let payload = {};
      let type = 'Excell';
      this.ExcelBtnName1 = "Downloading Please Wait";
      payload = {
        itemCode: "All_Webhook_List",
        type: 'Excell',
        Filter: null,
      };

      OceanInsightsSubscriptionService.getAllOceanWebhookList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data) {
            console.log("data=>",data)
            if (type == "Excell") {
              if (data.webhookList.length > 0) {
                this.webhookList = data.webhookList;
              }
              this.ExcelBtnName1 = "Webhook Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.webhookList.length > 0) {
                this.webhookList = data.webhookList;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on JOBList Error: ", error);
        });
    },
    getReportsAss(id, btnName) {
      let excelIdGivin = "";
      if (id == "MainAssignment_SCREEN") {
        excelIdGivin = "SUBSCRIPTION_SCREEN";
      } else if (id == "MainAssignment_All_Summary_SCREEN") {
        excelIdGivin = "All_Summary_SUBSCRIPTION_SCREEN";
      }
      let view_Assignment = {
        excelId: excelIdGivin,
        DateFilter: this.DateFilter,
        assignmentNo: "assignmentNo",
        searchVal: this.filter,
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
      };
      if (id == "MainAssignment_SCREEN") {
        this.ExcelBtnName = "Downloading please Wait...";
      } else if (id == "MainAssignment_All_Summary_SCREEN") {
        this.AllSummaryExcelBtnName = "Downloading please Wait...";
      }
      console.log(view_Assignment);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Tracking/reportsSubscriptionExcel.php`,
        data: JSON.stringify(view_Assignment),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.excelName != undefined) {
              if (id == "MainAssignment_SCREEN") {
                this.ExcelBtnName = btnName;
              } else if (id == "MainAssignment_All_Summary_SCREEN") {
                this.AllSummaryExcelBtnName = btnName;
              }
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },

    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewSubscription(CURRENT, "2", event);
    },
    proceedToManualInv() {
      this.$router.push({
        // path: "/allModuleForm/billing"
        path: "/allModuleForm/manualBill",
      });
    },
    filterSearch() {
      this.reload = false;
      this.viewSubscription("0", "1", "1");
    },
    clearFilter() {
      this.DateFilter = "";
      this.assignmentNo = "assignmentNo";
      this.viewSubscription("0", "1", "1");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewSubscription(CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },

    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },
    viewSubscription(CURRENT, SEARCH, pageNumber) {
      this.isLoading = true;
      let payload = {
        excelId: "",
        DateFilter: this.DateFilter,
        assignmentNo: this.assignmentNo,
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
      };
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Tracking/subscriptionTracking.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log("Report Data=>", data);
            this.subs_details = [];
            this.totalRows = data.totalData;
            if (data.SubscriptionData.length > 0) {
              this.subs_details = data.SubscriptionData;
            }
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            if (this.reload == true) {
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// totalSubscriptionTrack.vue?86160470